import _asyncToGenerator from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
export var getParaTextCount = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(width, text) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!width) {
              _context.next = 4;
              break;
            }
            _context.next = 3;
            return truncate(text, getTruncateChars(text));
          case 3:
            return _context.abrupt("return", _context.sent);
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getParaTextCount(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var truncate = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(str, len) {
    var HTMLString, htmlStr;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return import('HTMLString');
          case 2:
            HTMLString = _context2.sent;
            // Convert the string to a HTMLString
            htmlStr = new HTMLString.String(str);
            return _context2.abrupt("return", htmlStr.slice(0, len).html());
          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function truncate(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
export var getTextFromHTML = function getTextFromHTML(text) {
  if (text && text.length > 0) {
    var para = new DOMParser().parseFromString(text, 'text/html');
    return para.body.innerText;
  }
  return '';
};
var getTruncateChars = function getTruncateChars(text) {
  var _document$querySelect;
  var emergencyBanner = document.querySelector('#emergency-banner');
  if (!emergencyBanner) return;
  var canvas = document.createElement('canvas');
  canvas.style.cssText += 'display:none';
  document.body.appendChild(canvas);
  var parsedText = getTextFromHTML(text);
  var fillStr = '';
  var readMoreWidth = navigator && navigator.platform === 'iPhone' ? 150 : 100;
  var dummyPara = document.createElement('p');
  dummyPara.style.cssText = 'display:none';
  emergencyBanner.appendChild(dummyPara);
  var pDomTag = document.querySelector('#emergency-banner p');
  var fontFamily = window.getComputedStyle(pDomTag).fontFamily || 'OpenSansSemiBold, sans-serif';
  var fontSize = window.getComputedStyle(pDomTag).fontSize || (window.innerWidth >= 1024 ? '18px' : '16px');
  emergencyBanner.removeChild(dummyPara);
  var appWidth = ((_document$querySelect = document.querySelector('.wrapper')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetWidth) || (window.innerWidth > 1600 ? 1600 : window.innerWidth);
  for (var i = 0; i < parsedText.length; i++) {
    var ctx = canvas.getContext('2d');
    ctx.font = "".concat(fontSize, " ").concat(fontFamily);
    fillStr += parsedText[i];
    if (ctx.measureText(fillStr.split('').join(String.fromCharCode(8202))).width > (appWidth - 30) * 2 - readMoreWidth) {
      fillStr = fillStr.substr(0, Math.min(fillStr.length, fillStr.lastIndexOf(' ')));
      break;
    }
  }
  document.body.removeChild(canvas);
  return fillStr.length;
};